import React from "react";
import { Button } from "@mui/material";
import DownIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { IInstallments } from "repoV2/features/Payments/Payments.interface";
import { classNames } from "repoV2/utils/common/render/classNames";
import Installment from "../Installment/Installment";
import styles from "./InstallmentsSection.module.scss";

const InstallmentsSection = (props: {
    installmentsList: IInstallments[];
    currency: string;
    currencyLocale: string;
    showInstallments: boolean;
    setShowInstallments: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
    const {
        installmentsList,
        currency,
        currencyLocale,
        showInstallments,
        setShowInstallments,
    } = props;

    return (
        <div className={styles.mainContainer}>
            <Button
                endIcon={<DownIcon />}
                classes={{
                    root: styles.expandCta,
                    endIcon: classNames(
                        styles.endIcon,
                        showInstallments && styles.expandedIcon
                    ),
                }}
                onClick={e => {
                    e?.stopPropagation();
                    setShowInstallments(prev => !prev);
                }}
            >
                See plan
            </Button>
            {showInstallments && (
                <div>
                    {installmentsList.map((installment, index) => (
                        <Installment
                            key={installment.uuid}
                            installment={installment}
                            currency={currency}
                            currencyLocale={currencyLocale}
                            isFirstInstallment={index === 0}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default InstallmentsSection;
